<template>
  <div class="footer">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-3">
            <span class="copyright">© {{new Date().getFullYear()}} MightyGift</span>
          </div>
          <div class="col-12 col-sm-8 col-md-9">
            <ul class="footer__links">
              <li>
                <a :href="landingURL('faq')">FAQ</a>
              </li>
              <li>
                <a :href="landingURL('contact')">Contact</a>
              </li>
              <li>
                <a :href="landingURL('tos')">Terms of Service</a>
              </li>
              <li>
                <a :href="landingURL('privacy')">Privacy Policy</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'footer-nav',
  methods: {
    landingURL(path) {
      return `${process.env.PROTOCOL}://${process.env.LANDING_HOST}/${path}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/FooterNav.vue